import React, { FC, useEffect } from "react";
import { useForm, useFormState } from "react-final-form";
import { HousingType } from "../../../../constants";
import { AccommodationFees } from "../../../components/step3/AccommodationFees";
import Calculation from "../../../components/step3/Calculation";
import OtherFees from "../../../components/step3/OtherFees";
import Tuition from "../../../components/step3/Tuition";
import { IStepTemplate } from "../../../types";
import { DurationUnit } from "../../../../../../types";

const Template: FC<IStepTemplate> = ({ stepName }) => {
  const formState = useFormState();
  const { change } = useForm();

  const housingTypes =
    formState.values?.step1?.housingTypes || [];
  const boardingRequired = housingTypes.includes(HousingType.BOARDING);
  const homestayRequired = housingTypes.includes(HousingType.HOMESTAY);
  const durationUnit = formState.values?.[stepName]?.tuitionDurationUnit?.id;

  useEffect(() => {
    if (!boardingRequired) {
      change(`${stepName}.boardingAmount`, null);
    }
  }, [boardingRequired]);

  useEffect(() => {
    if (!homestayRequired) {
      change(`${stepName}.homestayAmount`, null);
    }
  }, [homestayRequired]);

  useEffect(() => {
    if (durationUnit === DurationUnit.FULL) {
      change(`${stepName}.tuitionDurationAmount`, null);
    }
  }, [durationUnit]);

  return (
    <>
      <Tuition
        name={stepName}
        durationAmountRequired={durationUnit !== DurationUnit.FULL}
      />
      <AccommodationFees
        name={stepName}
        boardingRequired={boardingRequired}
        homestayRequired={homestayRequired}
      />
      <OtherFees
        name={stepName}
        infoIcon={"You need to indicate every fee separately"}
      />
      <Calculation stepName={stepName} />
    </>
  );
};

export default Template;
